import { render } from "./TextLabelStats.vue?vue&type=template&id=92c04900&scoped=true&ts=true"
import script from "./TextLabelStats.vue?vue&type=script&lang=ts"
export * from "./TextLabelStats.vue?vue&type=script&lang=ts"

import "./TextLabelStats.vue?vue&type=style&index=0&id=92c04900&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92c04900"]])

export default __exports__